// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"value_emailAddress":{"b":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function accountMemberRole_decode($$enum) {
  if ($$enum === "ASSISTANT" || $$enum === "UNKNOWN" || $$enum === "ASSOCIATE" || $$enum === "TRANSACTION_COORDINATOR" || $$enum === "BUYER_SPECIALIST" || $$enum === "SHOWING_ASSISTANT" || $$enum === "CLIENT_CARE_COORDINATOR" || $$enum === "PARTNER" || $$enum === "INSIDE_SALES_AGENT" || $$enum === "OWNER" || $$enum === "LISTING_MANAGER" || $$enum === "OPERATIONS_MANAGER" || $$enum === "LISTING_SPECIALIST" || $$enum === "MARKETING_SPECIALIST") {
    return $$enum;
  }
}

let accountMemberRole_fromString = accountMemberRole_decode;

function accountStatusV5_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "TERMINATED") {
    return $$enum;
  }
}

let accountStatusV5_fromString = accountStatusV5_decode;

function agentPermissions_decode($$enum) {
  if ($$enum === "MEMBERSHIP_REQUESTS" || $$enum === "SWITCH_CHAPTER") {
    return $$enum;
  }
}

let agentPermissions_fromString = agentPermissions_decode;

let Utils = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: accountMemberRole_fromString,
  accountStatusV5_decode: accountStatusV5_decode,
  accountStatusV5_fromString: accountStatusV5_fromString,
  agentPermissions_decode: agentPermissions_decode,
  agentPermissions_fromString: agentPermissions_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true,
    "catchTo": "RESULT"
  },
  "name": "UserSessionAgentInfo_agent",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tanStaff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountMember",
      "kind": "LinkedField",
      "name": "membership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountV5",
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AccountMember",
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agent",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
